import { render, staticRenderFns } from "./GeneralChart.vue?vue&type=template&id=2ec09e9e&"
import script from "./GeneralChart.vue?vue&type=script&lang=js&"
export * from "./GeneralChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports